import React, { useCallback, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import useServiceProviderPortalAccess from "../hooks/useServiceProviderPortalAccess";
import { clearLocalStoarge } from "../helpers/utils";
import ServiceProviderPortalPrompt from "./ServiceProviderPortalPrompt";

/**
 * Shown when a service-provider role hits a consumer-only route (e.g. leftover
 * auth on ryan-staging after closing the redirect to servicer-*).
 * Avoids dumping them on /404 with a still-valid token.
 */
const ServiceProviderPortalMismatchGate = () => {
  const navigate = useNavigate();
  const {
    canUseServiceProviderPortal,
    goToServiceProviderPortal,
    stayOnConsumerSite,
    hasCustomerRole,
  } = useServiceProviderPortalAccess();
  const [ready, setReady] = useState(canUseServiceProviderPortal);

  useEffect(() => {
    if (canUseServiceProviderPortal) {
      setReady(true);
      return;
    }
    clearLocalStoarge();
    navigate("/", { replace: true });
  }, [canUseServiceProviderPortal, navigate]);

  const handleStay = useCallback(() => {
    const result = stayOnConsumerSite();
    if (result.switchedToCustomer) {
      window.location.replace("/properties");
      return;
    }
    clearLocalStoarge();
    navigate("/", { replace: true });
  }, [navigate, stayOnConsumerSite]);

  if (!ready) {
    return null;
  }

  return (
    <ServiceProviderPortalPrompt
      open
      forceChoice
      hasCustomerRole={hasCustomerRole}
      onStay={handleStay}
      onGoToServiceProvider={goToServiceProviderPortal}
    />
  );
};

export default ServiceProviderPortalMismatchGate;
